import contactWayFormModel from './contactWayFormModel.vue';
import { systemConfigResourse } from '../request';
export default {
  components: {
    contactWayFormModel
  },
  data() {
    return {
      collapses: [{
        title: '简体中文',
        key: 'zh'
      }, {
        title: '繁体中文',
        key: 'cht'
      }, {
        title: '英语',
        key: 'en'
      }, {
        title: '法语',
        key: 'fra'
      }, {
        title: '西班牙语',
        key: 'spa'
      }],
      datas: {},
      formModel: {
        icon: '',
        copyWriting: ''
      },
      type: '1' //联系方式
    };
  },
  mounted() {
    this.getSystemConfig();
  },
  methods: {
    async getSystemConfig() {
      let res = await systemConfigResourse({
        type: this.type
      });
      this.datas = res;
    }
  }
};